import React, { useTransition } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Back from "shared/assets/images/svg/back_blue.svg";
import Input from "shared/component/inputFields";
import { usePreferences } from "customer/settings/preferences/preferences.service";
import { Spinner } from "react-bootstrap";
import { useLookups } from "shared/hooks/use-lookups";
import { localize } from "shared/helpers/utils";




const Preferences = () => {
  const {t}=useTranslation();
  const {
    ownerPerfrences,
    register,
    formState: { errors },
    handleSubmit,
    changeCompanyInfo,
    isLoading,
    languages,
    periods,
    watch,
  } = usePreferences();

  const { defaultFilterPeriodId, languageId } = watch();

  return (
    <form className="settingHome companyInfo" onSubmit={handleSubmit(changeCompanyInfo)}>
      <div className="container">
        <div className="header">
          <div className="page-name">
            <Link className="linkBack" to="/settings">
              <img src={Back} alt="back" />
            </Link>
            <h1>{t('prefrences.prefrence')}</h1>
          </div>
        </div>
        <hr className="hr" />
        <div className="row">
          <div className="col-lg-5 col-md-6">
            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('prefrences.default')} <small className="star-require">*</small>
              </label>
              <div className="col-lg-8">
                <Input
                  type="select"
                  require
                  value={languageId}
                  error={errors.languageId?.message}
                  {...register("languageId")}
                  options={languages}
                  getOptionLabel={(z) => localize(z.name)}
                />
              </div>
            </div>
            <div className="form-group form-div mt-0 row g-3 align-items-center">
              <label className="col-lg-4 col-form-label ">
              {t('prefrences.filter')} <small className="star-require">*</small>
              </label>
              <div className="col-lg-8">
                <Input
                  require
                  type="select"
                  value={defaultFilterPeriodId}
                  error={errors.defaultFilterPeriodId?.message}
                  {...register("defaultFilterPeriodId")}
                  options={periods}
                  getOptionLabel={(z) => localize(z.name)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="action">
        <div className="container">
          <button type="submit" className="btn-blue" >
            <Spinner animation="border" size="sm" hidden={!isLoading} />
            {t('common.save')}
          </button>
        </div>
      </div>
    </form>
  );
};

export default Preferences;
